/* import __COLOCATED_TEMPLATE__ from './signup-continue-setup.hbs'; */
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';

const SignupContinueSetupComponent = Component.extend({
  /** @inheritDoc */
  tagName: 'section',

  /** @inheritDoc */
  classNames: ['GLM-freelancer-signup-done'],

  /** @type {Ember.ComputedProperty} */
  firstName: readOnly('user.firstName'),

  /** @type {boolean} */
  submitting: false,

  /** @inheritDoc */
  actions: {
    /**
     *
     */
    handleClick() {
      this.set('submitting', true);
      this.get('next')();
    },
  },
});

export default SignupContinueSetupComponent;
